export default "__VITE_ASSET__RS1VA3SY__"